import * as React from 'react';
import { Component } from 'react';
import './StatusBar.css';


interface IState {
    Message: string,
    Type: 'Success' | 'Info' | 'Error',
    Timeout?: number,
    Visible: boolean
}

export class StatusBarComponent extends Component<any, IState> {
    constructor(props) {
        super(props);
        
        this.state = {
            Message: '',
            Type: 'Info',
            Visible: false
        }

        this.ShowStatusBar = this.ShowStatusBar.bind(this);
        this.InitCloseTimeout = this.InitCloseTimeout.bind(this);
        this.Close = this.Close.bind(this);
    }

    public ShowStatusBar(type: 'Success' | 'Info' | 'Error', message: string, timeout?: number) {
        this.setState({
            Message: message,
            Type: type,
            Visible: true,
            Timeout: timeout
        });
    }

    public render() {
        if (this.state.Visible) {
            if (this.state.Timeout) {
                this.InitCloseTimeout(this.state.Timeout);
            }
            return (
                <div className="status-bar-component">
                    <div onClick={this.Close} className={'message-container ' + this.state.Type.toLowerCase()}>
                        <div className="close-btn">x</div>
                        <div className="message-icon" />
                        <div className="message">
                            {this.state.Message}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private InitCloseTimeout(timeout: number) {
        setTimeout((t) => {
            t.setState({
                Visible: false
            });
        }, timeout, this);
    }

    private Close(evt) {
        this.setState({
            Visible: false
        });
    }
}


// WEBPACK FOOTER //
// ./src/controls/StatusBar.tsx